export const setSavings = (savings) => ({
  type: "SET_SAVINGS",
  payload: savings,
});

export default setSavings;
